const ProcessSlider = () => {
  const sliderWrapper = document.querySelector(".process-slider__slider-wrapper");

  if (sliderWrapper) {
    const smallItems = [...document.querySelectorAll(".process-slider__small-slider-item")];
    const smallItemsMobile = [...document.querySelectorAll(".process-slider__big-slider-mobile-btn")];
    const bigItems = [...document.querySelectorAll(".process-slider__big-slider-item")];
    const progressBar = document.querySelector(".process-slider__progress-bar");

    let currentIndex = 0;
    let autoSwitch;
    const stepDuration = 10000;
    const totalSteps = smallItems.length;
    let isAnimationStarted = false; 

    const isMobile = () => window.innerWidth < 768;

    const updateProgress = (index) => {
      if (!progressBar) return;

      progressBar.style.transition = "none";
      progressBar.style.height = `${(index * 100) / totalSteps}%`;

      setTimeout(() => {
        progressBar.style.transition = `height ${stepDuration}ms linear`;
        progressBar.style.height = `${((index + 1) * 100) / totalSteps}%`;
      }, 50);
    };

    const setActiveTab = (index, isClick = false) => {
      smallItems.forEach((item) => item.classList.remove("active"));
      smallItemsMobile.forEach((item) => item.classList.remove("active"));
      bigItems.forEach((item) => item.classList.remove("active"));

      smallItems[index].classList.add("active");
      smallItemsMobile[index].classList.add("active");
      bigItems[index].classList.add("active");

      if (isClick && isMobile()) {
        bigItems[index].scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      currentIndex = index;
      updateProgress(index);
      resetAutoSwitch();
    };

    const nextTab = () => {
      let nextIndex = (currentIndex + 1) % totalSteps;
      setActiveTab(nextIndex);
    };

    const startAutoSwitch = () => {
      clearInterval(autoSwitch);
      autoSwitch = setInterval(nextTab, stepDuration);
    };

    const resetAutoSwitch = () => {
      clearInterval(autoSwitch);
      startAutoSwitch();
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !isAnimationStarted) {
          isAnimationStarted = true; 
          if (smallItems.length > 0 && bigItems.length > 0) {
            setActiveTab(0);
            startAutoSwitch();

            smallItems.forEach((smallItem, index) => {
              smallItem.addEventListener("click", () => setActiveTab(index, true));
            });

            smallItemsMobile.forEach((smallItemMobile, index) => {
              smallItemMobile.addEventListener("click", () => setActiveTab(index, true));
            });
          }
        }
      },
      { threshold: 0.5 } 
    );

    observer.observe(sliderWrapper);
  }
};

export default ProcessSlider;
